export default __webpack_public_path__ + "static/media/ni.6805d80b.jpg";